// ================================================================
// WhatsApp-View — Chat-Panel, Instanzen, Verbinden/QR, Medien, Polling,
// Auto-Antwort-Modal.
// ================================================================
// Herausgelöst aus CompanyDashboard.js (Datei-Split, Runde 2 — 2026-07-19).
// Gleicher Injektions-Ansatz wie documentsView.js/sendModal.js: geteilter
// State `s` + draw kommen einmal via initWhatsappView(); getRoot liefert das
// Mount-Element (wird erst beim Mount gesetzt), whatsappKpis bleibt (noch)
// bei den Dashboard-Widgets in CompanyDashboard.
import { t } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';
import { listWhatsAppInstances, createWhatsAppInstance, removeWhatsAppInstance, updateWhatsAppInstanceLabel, connectWhatsApp, getWhatsAppStatus, disconnectWhatsApp, getWhatsAppChats, getWhatsAppMessages, sendWhatsAppMessage, sendWhatsAppVoice, getWhatsAppMediaBlob } from '../../core/whatsapp.js';
import { loadWaDraft, renderWaDraft } from './wa-draft-ui.js';

let s;
let draw;
let whatsappKpis;
let getRoot;
let waPollTimer = null;
let waChatsPollTimer = null;

/** Einmal beim Modul-Start von CompanyDashboard aufrufen. */
export function initWhatsappView(ctx) {
  ({ s, draw, whatsappKpis, getRoot } = ctx);
}

// ── ارسال پیام واتساپ ──────────────────────────────────────

// فعال/غیرفعال کردن دکمه ارسال هنگام تایپ (بدون redraw کامل، تا فوکوس نپرد)
export function updateSendButton() {
  if (!getRoot()) return;
  const container = getRoot().querySelector('#cd-root');
  if (!container) return;
  const btn = container.querySelector('[data-action="send-wa"]');
  if (btn) btn.disabled = s.waSending || !s.waDraft.trim();
  const voiceBtn = container.querySelector('[data-action="send-wa-voice"]');
  if (voiceBtn) voiceBtn.disabled = s.waSending || !s.waDraft.trim();
}

// email-chat-send: ersal-e email az dakhel-e tab-e Emails (be moshtari)


// whatsapp-chat-send: ersal-e WhatsApp az dakhel-e tab (be moshtari, bar asas-e phone)


export async function sendWaMessage() {
  const text = (s.waDraft || '').trim();
  if (!text || !s.waActiveChat || s.waSending) return;
  s.waSending = true;
  const jid = s.waActiveChat;
  if (s.view === 'whatsapp') draw();
  try {
    await sendWhatsAppMessage(s.waActiveInstance, jid, text);
    s.waDraft = '';
    // پیام‌ها را فوراً رفرش کن تا پیام ارسالی دیده شود
    const res = await getWhatsAppMessages(s.waActiveInstance, jid);
    s.waMessages = res.messages || [];
    // لیست چت‌ها را هم به‌روز کن (ترتیب/زمان)
    refreshWaChats();
  } catch (e) {
    console.error('sendWaMessage:', e);
    alert(t('dashboard.whatsapp.errSendMessage') + (e.message || t('dashboard.whatsapp.unknownError')));
  } finally {
    s.waSending = false;
    if (s.view === 'whatsapp') draw();
  }
}

// ارسالِ پیامِ صوتی (متن → صوت) از کادرِ تایپ
export async function sendWaVoiceMessage() {
  const text = (s.waDraft || '').trim();
  if (!text || !s.waActiveChat || s.waSending) return;
  s.waSending = true;
  const jid = s.waActiveChat;
  if (s.view === 'whatsapp') draw();
  try {
    await sendWhatsAppVoice(s.waActiveInstance, jid, text);
    s.waDraft = '';
    const res = await getWhatsAppMessages(s.waActiveInstance, jid);
    s.waMessages = res.messages || [];
    refreshWaChats();
  } catch (e) {
    console.error('sendWaVoiceMessage:', e);
    alert(t('dashboard.whatsapp.errSendVoice') + (e.message || t('dashboard.whatsapp.unknownError')));
  } finally {
    s.waSending = false;
    if (s.view === 'whatsapp') draw();
  }
}

// ── WhatsApp chat panel UI ─────────────────────────────────
// شماره‌ی واتساپِ متصل را به فرمت خوانا درمی‌آورد (E.164 ساده)
export function fmtWaPhone(num) {
  if (!num) return '';
  var d = String(num).replace(/[^0-9]/g, '');
  if (!d) return '';
  return '+' + d;
}

export function fmtWaTime(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}


// رفرش لیست چت هنگام تایپ در جستجو (draw با حفظ فوکوس)
export function renderWaChatList() {
  if (s.view === 'whatsapp') draw();
}

export function renderWaMedia(m) {
  var jid = s.waActiveChat || '';
  var mid = m.messageId;
  var c = s.waMediaCache[mid] || null;
  var esc = escapeHtml;
  if (m.messageType === 'image') {
    if (c) return '<div class="cd-wa-media-wrap"><img class="cd-wa-img" src="' + c + '" data-action="open-lightbox" data-mid="' + esc(mid) + '" alt="" /></div>';
    return '<div class="cd-wa-media-wrap cd-wa-media-loading" data-media-id="' + esc(mid) + '" data-media-jid="' + esc(jid) + '" data-media-type="image">' + icon('image', 36) + '<span>' + esc(t('common.loading')) + '</span></div>';
  }
  if (m.messageType === 'video') {
    if (c) return '<div class="cd-wa-media-wrap"><video class="cd-wa-video" src="' + c + '" controls preload="metadata"></video></div>';
    return '<div class="cd-wa-media-wrap cd-wa-media-loading" data-media-id="' + esc(mid) + '" data-media-jid="' + esc(jid) + '" data-media-type="video">' + icon('videocam', 36) + '<span>' + esc(t('common.loading')) + '</span></div>';
  }
  if (m.messageType === 'audio') {
    if (c) return '<div class="cd-wa-media-wrap"><audio class="cd-wa-audio" src="' + c + '" controls preload="metadata"></audio></div>';
    return '<div class="cd-wa-media-wrap cd-wa-media-loading" data-media-id="' + esc(mid) + '" data-media-jid="' + esc(jid) + '" data-media-type="audio">' + icon('mic', 36) + '<span>' + esc(t('common.loading')) + '</span></div>';
  }
  if (m.messageType === 'document') {
    var nm = esc(m.fileName || m.content || mid);
    if (m.fromMe) {
      return '<div class="cd-wa-media-wrap"><div class="cd-wa-doc cd-wa-doc-sent">' + icon('description', 20) + '<span>' + nm + '</span></div></div>';
    }
    if (c) return '<div class="cd-wa-media-wrap"><a class="cd-wa-doc" href="' + c + '" download="' + nm + '">' + icon('description', 20) + '<span>' + nm + '</span></a></div>';
    return '<div class="cd-wa-media-wrap cd-wa-media-loading" data-media-id="' + esc(mid) + '" data-media-jid="' + esc(jid) + '" data-media-type="document">' + icon('description', 36) + '<span>' + esc(t('common.loading')) + '</span></div>';
  }
  return '<div class="cd-wa-bubble-text"><em>[' + esc(m.messageType) + ']</em></div>';
}

export async function hydrateWaMedia() {
  const ct = getRoot() && getRoot().querySelector('#cd-root');
  if (!ct) return;
  const els = Array.from(ct.querySelectorAll('[data-media-id]'));
  for (const el of els) {
    const mid = el.dataset.mediaId;
    const jid = el.dataset.mediaJid;
    const mtype = el.dataset.mediaType;
    if (!mid || !jid || s.waMediaLoading[mid] || s.waMediaCache[mid]) continue;
    s.waMediaLoading[mid] = true;
    try {
      const blob = await getWhatsAppMediaBlob(s.waActiveInstance, jid, mid);
      const url = URL.createObjectURL(blob);
      s.waMediaCache[mid] = url;
      const fresh = ct.querySelector('[data-media-id="' + mid + '"]');
      if (!fresh) { delete s.waMediaLoading[mid]; continue; }
      var h;
      if (mtype === 'image') h = '<div class="cd-wa-media-wrap"><img class="cd-wa-img" src="' + url + '" data-action="open-lightbox" data-mid="' + mid + '" alt="" /></div>';
      else if (mtype === 'video') h = '<div class="cd-wa-media-wrap"><video class="cd-wa-video" src="' + url + '" controls preload="metadata"></video></div>';
      else if (mtype === 'audio') h = '<div class="cd-wa-media-wrap"><audio class="cd-wa-audio" src="' + url + '" controls preload="metadata"></audio></div>';
      else { var sp = fresh.querySelector('span'); var nm2 = sp ? sp.textContent : mid; h = '<div class="cd-wa-media-wrap"><a class="cd-wa-doc" href="' + url + '" download="' + nm2 + '">' + icon('description', 20) + '<span>' + nm2 + '</span></a></div>'; }
      fresh.outerHTML = h;
    } catch(e) { console.error('[wa media] hydrate id=' + mid, e); }
    finally { delete s.waMediaLoading[mid]; }
  }
}

export function whatsappChatPanel() {
  // لیست چت‌ها (ستون چپ)
  let chatList;
  if (s.waChatsLoading && s.waChats.length === 0) {
    chatList = `<div class="cd-wa-empty">${icon('hourglass_empty', 18)} ${escapeHtml(t('dashboard.whatsapp.loadingChats'))}</div>`;
  } else if (s.waChats.length === 0) {
    chatList = `<div class="cd-wa-empty">${icon('chat', 22)}<span>${escapeHtml(t('dashboard.whatsapp.noConversations'))}</span><small>${escapeHtml(t('dashboard.whatsapp.noConversationsSub'))}</small></div>`;
  } else {
    const q = s.waSearch.trim().toLowerCase();
    const visible = q
      ? s.waChats.filter((c) =>
          (c.contactName || '').toLowerCase().includes(q) ||
          (c.pushName || '').toLowerCase().includes(q) ||
          c.remoteJid.toLowerCase().includes(q))
      : s.waChats;
    if (visible.length === 0) {
      chatList = `<div class="cd-wa-empty"><span>${escapeHtml(t('dashboard.whatsapp.noMatches'))}</span></div>`;
    } else {
    chatList = visible.map((c) => {
      const name = c.contactName || c.pushName || c.remoteJid.split('@')[0];
      const active = c.remoteJid === s.waActiveChat ? 'active' : '';
      const unread = c.unreadCount > 0 ? `<span class="cd-wa-badge">${c.unreadCount}</span>` : '';
      return `<button class="cd-wa-chat ${active}" data-action="open-wa-chat" data-jid="${escapeHtml(c.remoteJid)}">
        <div class="cd-wa-avatar">${escapeHtml(name.charAt(0).toUpperCase())}</div>
        <div class="cd-wa-chat-main">
          <div class="cd-wa-chat-name">${escapeHtml(name)}</div>
          <div class="cd-wa-chat-jid">${escapeHtml(c.remoteJid.split('@')[0])}</div>
        </div>
        ${unread}
      </button>`;
    }).join('');
    }
  }

  // ناحیه پیام‌ها (ستون راست)
  let messageArea;
  if (!s.waActiveChat) {
    messageArea = `<div class="cd-wa-empty cd-wa-pick">${icon('chat', 26)}<span>${escapeHtml(t('dashboard.whatsapp.selectConversation'))}</span><small>${escapeHtml(t('dashboard.whatsapp.selectConversationSub'))}</small></div>`;
  } else if (s.waMessagesLoading && s.waMessages.length === 0) {
    messageArea = `<div class="cd-wa-empty">${icon('hourglass_empty', 18)} ${escapeHtml(t('dashboard.whatsapp.loadingMessages'))}</div>`;
  } else if (s.waMessages.length === 0) {
    messageArea = `<div class="cd-wa-empty"><span>${escapeHtml(t('dashboard.whatsapp.noMessages'))}</span></div>`;
  } else {
    const bubbles = s.waMessages.map((m) => {
      const cls = m.fromMe ? 'me' : 'them';
      // «für alle gelöscht»: Inhalt und Datei sind serverseitig weg — die Blase
      // bleibt als Spur stehen, damit im CRM sichtbar ist, DASS etwas kam.
      if (m.revokedAt) {
        return `<div class="cd-wa-bubble ${cls} revoked">
          <div class="cd-wa-bubble-text">${icon('block', 15)} <em>${escapeHtml(t('dashboard.whatsapp.revoked'))}</em></div>
          <div class="cd-wa-bubble-time">${fmtWaTime(m.timestamp)}</div>
        </div>`;
      }
      const isMedia = ['image', 'audio', 'video', 'document'].includes(m.messageType);
      let body;
      if (!isMedia) {
        body = `<div class="cd-wa-bubble-text">${m.content ? escapeHtml(m.content) : `<em>[${escapeHtml(m.messageType)}]</em>`}</div>`;
      } else if (m.mediaPending) {
        body = `<div class="cd-wa-media-pending">${icon('hourglass_empty', 16)} <span>${escapeHtml(t('common.loading'))}</span></div>`;
      } else {
        body = renderWaMedia(m);
      }
      const caption = (isMedia && m.content) ? `<div class="cd-wa-bubble-text cd-wa-media-cap">${escapeHtml(m.content)}</div>` : '';
      return `<div class="cd-wa-bubble ${cls}">
        ${body}${caption}
        <div class="cd-wa-bubble-time">${fmtWaTime(m.timestamp)}</div>
      </div>`;
    }).join('');
    const activeChat = s.waChats.find((c) => c.remoteJid === s.waActiveChat);
    const title = activeChat ? (activeChat.contactName || activeChat.pushName || activeChat.remoteJid.split('@')[0]) : '';
    messageArea = `<div class="cd-wa-msg-head"><span class="cd-wa-msg-title">${escapeHtml(title)}</span></div><div class="cd-wa-msg-scroll">${bubbles}</div>`;
  }

  // باکس تایپ (فقط وقتی چتی باز است)
  const composer = s.waActiveChat ? `
    <div class="cd-wa-composer">
      <input id="cd-wa-input" class="cd-wa-input" type="text" placeholder="${escapeHtml(t('dashboard.whatsapp.typeMessage'))}" value="${escapeHtml(s.waDraft)}" autocomplete="off" ${s.waSending ? 'disabled' : ''} />
      <button class="cd-wa-voice" data-action="send-wa-voice" title="${escapeHtml(t('dashboard.whatsapp.sendAsVoice'))}" ${s.waSending || !s.waDraft.trim() ? 'disabled' : ''}>${icon('mic', 18)}</button>
      <button class="cd-wa-send" data-action="send-wa" ${s.waSending || !s.waDraft.trim() ? 'disabled' : ''}>${icon(s.waSending ? 'hourglass_empty' : 'send', 18)}</button>
    </div>` : '';

  return `<div class="cd-wa-panel">
    <div class="cd-wa-sidebar">
      <div class="cd-wa-sidebar-switcher">${waTabBar()}</div>
      <div class="cd-wa-search-wrap">
        ${icon('search', 16)}
        <input id="cd-wa-search" class="cd-wa-search" type="text" placeholder="${escapeHtml(t('dashboard.whatsapp.searchChats'))}" value="${escapeHtml(s.waSearch)}" autocomplete="off" />
      </div>
      <div class="cd-wa-chat-list">${chatList}</div>
      <div class="cd-wa-foot">
        <button class="cd-wa-gear" data-action="toggle-wa-settings" title="${escapeHtml(t('dashboard.settings'))}">${icon('settings', 18)}</button>
        ${s.waSettingsOpen ? `<div class="cd-wa-menu">
          <button class="cd-wa-menu-item" data-action="add-instance">${icon('add', 16)}${escapeHtml(t('dashboard.whatsapp.addNumber'))}</button>
          <button class="cd-wa-menu-item" data-action="rename-instance">${icon('edit', 16)}${escapeHtml(t('dashboard.whatsapp.rename'))}</button>
          <button class="cd-wa-menu-item cd-wa-menu-danger" data-action="disconnect-whatsapp">${icon('link_off', 16)}${escapeHtml(t('dashboard.whatsapp.disconnect'))}</button>
          <button class="cd-wa-menu-item cd-wa-menu-danger" data-action="remove-instance">${icon('delete', 16)}${escapeHtml(t('dashboard.whatsapp.removeNumber'))}</button>
        </div>` : ''}
      </div>
    </div>
    <div class="cd-wa-main">${messageArea}${renderWaDraft(s)}${composer}</div>
  </div>`;
}

export function waTabBar() {
  if (!s.waInstances || s.waInstances.length === 0) return '';
  const cur = s.waInstances.find((i) => i.id === s.waActiveInstance) || s.waInstances[0];
  const curLabel = cur ? (cur.label || (cur.phoneNumber ? fmtWaPhone(cur.phoneNumber) : t('dashboard.whatsapp.newNumber'))) : t('dashboard.whatsapp.selectNumber');
  const curDot = cur && cur.status === 'connected' ? '<span class="cd-wa-sw-dot"></span>' : '';
  const open = s.waSwitcherOpen ? ' open' : '';

  let menu = '';
  if (s.waSwitcherOpen) {
    const items = s.waInstances.map((i) => {
      const active = i.id === s.waActiveInstance ? ' active' : '';
      const labelTxt = i.label || (i.phoneNumber ? fmtWaPhone(i.phoneNumber) : t('dashboard.whatsapp.newNumber'));
      const dot = i.status === 'connected' ? '<span class="cd-wa-sw-dot"></span>' : '<span class="cd-wa-sw-dot off"></span>';
      const check = i.id === s.waActiveInstance ? '<span class="cd-wa-sw-check">\u2713</span>' : '';
      return `<button class="cd-wa-sw-item${active}" data-action="switch-instance" data-iid="${escapeHtml(i.id)}">${dot}<span class="cd-wa-sw-item-label">${escapeHtml(labelTxt)}</span>${check}</button>`;
    }).join('');
    menu = `<div class="cd-wa-sw-menu">
      ${items}
      <button class="cd-wa-sw-add" data-action="add-instance">${icon('add', 16)}<span>${escapeHtml(t('dashboard.whatsapp.addNumber'))}</span></button>
    </div>`;
  }

  return `<div class="cd-wa-switcher${open}">
    <button class="cd-wa-sw-trigger" data-action="toggle-switcher">
      ${curDot}<span class="cd-wa-sw-cur">${escapeHtml(curLabel)}</span>${icon('expand_more', 18)}
    </button>
    ${menu}
  </div>`;
}

export function whatsappPage() {
  const header = (sub) => `
    <header class="cd-topbar">
      <div class="cd-greeting">
        <h1>${escapeHtml(t('dashboard.nav.whatsapp'))}</h1>
        <p>${escapeHtml(sub)}</p>
      </div>
      <span></span>
    </header>`;

  let body;

  // هیچ instance ای وجود ندارد → افزودن اولین شماره
  if (!s.waLoading && (s.waInstances || []).length === 0) {
    const empty = `<div class="cd-connect">
      <div class="cd-connect-ic">${icon('chat', 30)}</div>
      <div class="cd-connect-title">${escapeHtml(t('dashboard.whatsapp.noNumbersTitle'))}</div>
      <div class="cd-connect-sub">${escapeHtml(t('dashboard.whatsapp.noNumbersSub'))}</div>
      <button class="cd-btn-primary cd-btn-sm" data-action="add-instance">${icon('add', 16)}${escapeHtml(t('dashboard.whatsapp.addNumber'))}</button>
    </div>`;
    return `${header(t('dashboard.whatsapp.sendReceiveSub'))}<div class="cd-card">${empty}</div>`;
  }

  if (s.waError) {
    body = `<div class="cd-connect">
      <div class="cd-connect-ic">${icon('error', 30)}</div>
      <div class="cd-connect-title">${escapeHtml(t('dashboard.whatsapp.couldNotConnect'))}</div>
      <div class="cd-connect-sub">${escapeHtml(s.waError)}</div>
      <button class="cd-btn-primary cd-btn-sm" data-action="connect-whatsapp">${icon('refresh', 16)}${escapeHtml(t('dashboard.whatsapp.tryAgain'))}</button>
    </div>`;
  } else if (s.waConnected) {
    body = whatsappChatPanel();
  } else if (s.waQr) {
    body = `<div class="cd-wa-qr">
      <div class="cd-wa-qr-title">${escapeHtml(t('dashboard.whatsapp.scanToConnect'))}</div>
      <div class="cd-wa-qr-sub">${escapeHtml(t('dashboard.whatsapp.scanToConnectSub'))}</div>
      <div class="cd-wa-qr-img"><img src="${s.waQr}" alt="${escapeHtml(t('dashboard.whatsapp.qrAlt'))}" /></div>
      ${s.waPairing ? `<div class="cd-wa-qr-pair">${escapeHtml(t('dashboard.whatsapp.orPairingCode'))} <strong>${escapeHtml(s.waPairing)}</strong></div>` : `
      <div class="cd-wa-pair-req">
        <input id="cd-wa-pair-phone" class="cd-wa-input" type="tel" placeholder="+41 79 123 45 67" value="${escapeHtml(s.waPairPhone || '')}" autocomplete="off" />
        <button class="cd-btn-ghost cd-btn-sm" data-action="request-pair-code">${icon('pin', 15)}${escapeHtml(t('dashboard.whatsapp.requestPairCode'))}</button>
      </div>`}
      <div class="cd-wa-qr-foot">
        <span class="cd-muted">${icon('hourglass_empty', 14)} ${escapeHtml(t('dashboard.whatsapp.waitingForScan'))}</span>
        <button class="cd-btn-ghost cd-btn-sm" data-action="refresh-qr">${icon('refresh', 15)}${escapeHtml(t('dashboard.whatsapp.refreshQr'))}</button>
      </div>
    </div>`;
  } else if (s.waConnecting || s.waLoading) {
    body = `<div class="cd-connect"><div class="cd-muted">${icon('hourglass_empty', 18)} ${escapeHtml(s.waConnecting ? t('dashboard.whatsapp.generatingQr') : t('common.loading'))}</div></div>`;
  } else {
    body = `<div class="cd-connect">
      <div class="cd-connect-ic">${icon('chat', 30)}</div>
      <div class="cd-connect-title">${escapeHtml(t('dashboard.whatsapp.noAccountTitle'))}</div>
      <div class="cd-connect-sub">${escapeHtml(t('dashboard.whatsapp.noAccountSub'))}</div>
      <button class="cd-btn-primary cd-btn-sm" data-action="connect-whatsapp">${icon('add', 16)}${escapeHtml(t('dashboard.whatsapp.connectWhatsapp'))}</button>
    </div>`;
  }

  // وقتی وصل است: پنل تمام‌قد، بدون header و بدون card
  if (s.waConnected) {
    return `<div class="cd-wa-page">${whatsappKpis()}${body}</div>`;
  }
  // حالت‌های دیگر (QR/خطا/وصل‌نشده): header + card معمول
  const sub = t('dashboard.whatsapp.sendReceiveSub');
  return `${header(sub)}${waTabBar()}<div class="cd-card">${body}</div>`;
}


// ── WhatsApp chats/messages ───────────────────────────────
export async function loadWaChats() {
  s.waChatsLoading = true;
  if (s.view === 'whatsapp') draw();
  try {
    const res = await getWhatsAppChats(s.waActiveInstance);
    s.waChats = res.chats || [];
  } catch (e) {
    console.error('loadWaChats:', e);
  } finally {
    s.waChatsLoading = false;
    if (s.view === 'whatsapp') draw();
  }
}

export async function openWaChat(remoteJid) {
  s.waActiveChat = remoteJid;
  s.waMessages = [];
  s.waMessagesLoading = true;
  if (s.view === 'whatsapp') draw();
  try {
    const res = await getWhatsAppMessages(s.waActiveInstance, remoteJid);
    s.waMessages = res.messages || [];
    // چت را خوانده‌شده علامت بزن (در UI)
    const chat = s.waChats.find((c) => c.remoteJid === remoteJid);
    if (chat) chat.unreadCount = 0;
    s.waScrollToBottom = true; // baad az baz kardan-e chat boro ta akharin payam
    // درافتِ پیشنهادیِ AI این چت را هم بگیر
    loadWaDraft(waDraftCtx());
  } catch (e) {
    console.error('openWaChat:', e);
  } finally {
    s.waMessagesLoading = false;
    if (s.view === 'whatsapp') draw();
  }
}

// ctx برای ماژولِ درافت: state، draw، و تازه‌سازیِ پیام‌ها را تزریق می‌کند
export function waDraftCtx() {
  return {
    s,
    draw,
    reloadMessages: async () => {
      if (!s.waActiveChat) return;
      try {
        const res = await getWhatsAppMessages(s.waActiveInstance, s.waActiveChat);
        s.waMessages = res.messages || [];
        s.waScrollToBottom = true;
      } catch (e) { /* ignore */ }
    },
  };
}

// ── مدیریت instance (سوییچ/افزودن/حذف/تغییرنام) ──────────────
export function resetWaPerInstanceState() {
  // objectURLهای مدیا را آزاد کن تا نشت حافظه نشود
  for (const k in s.waMediaCache) { try { URL.revokeObjectURL(s.waMediaCache[k]); } catch { /* ignore */ } }
  s.waMediaCache = {}; s.waMediaLoading = {};
  s.waConnected = false; s.waStatus = 'pending'; s.waQr = ''; s.waPairing = ''; s.waPhone = null;
  s.waChats = []; s.waActiveChat = null; s.waMessages = [];
  s.waSearch = ''; s.waDraft = ''; s.waSettingsOpen = false;
  s.waDraftData = null; s.waDraftText = ''; s.waDraftLoading = false;
  stopWaPoll(); stopWaChatsPoll();
}

export async function switchWaInstance(instanceId) {
  s.waSwitcherOpen = false;
  if (!instanceId || instanceId === s.waActiveInstance) { s.waSettingsOpen = false; draw(); return; }
  resetWaPerInstanceState();
  s.waActiveInstance = instanceId;
  try { localStorage.setItem('lu_wa_last_instance', instanceId); } catch (e) {}
  draw();
  await loadWaStatus();
}

export async function addWaInstance() {
  s.waSwitcherOpen = false;
  s.waSettingsOpen = false; s.waError = ''; draw();
  try {
    const createdRes = await createWhatsAppInstance(null);
    const created = (createdRes && createdRes.instance) || createdRes;
    await loadWaInstances();            // لیست را تازه کن
    if (created && created.id) {
      resetWaPerInstanceState();
      s.waActiveInstance = created.id;  // روی شماره‌ی تازه برو
      draw();
      await connectWa();                // مستقیم QR بگیر
    }
  } catch (e) {
    s.waError = e.message || t('dashboard.whatsapp.errAddNumber');
    draw();
  }
}

export async function removeWaInstance() {
  if (!s.waActiveInstance) return;
  s.waSettingsOpen = false;
  const cur = s.waInstances.find((i) => i.id === s.waActiveInstance);
  const name = cur ? (cur.label || fmtWaPhone(cur.phoneNumber) || t('dashboard.whatsapp.thisNumber')) : t('dashboard.whatsapp.thisNumber');
  if (!confirm(t('dashboard.whatsapp.confirmRemove', { name }))) { draw(); return; }
  try {
    resetWaPerInstanceState();
    await removeWhatsAppInstance(s.waActiveInstance);
    s.waActiveInstance = null;
    await loadWaInstances();            // اولین باقی‌مانده را می‌گیرد یا empty-state
  } catch (e) {
    s.waError = e.message || t('dashboard.whatsapp.errRemoveNumber');
    draw();
  }
}

export async function renameWaInstance() {
  if (!s.waActiveInstance) return;
  s.waSettingsOpen = false;
  const cur = s.waInstances.find((i) => i.id === s.waActiveInstance);
  const next = prompt(t('dashboard.whatsapp.renamePrompt'), cur ? (cur.label || '') : '');
  if (next === null) { draw(); return; }   // لغو
  try {
    await updateWhatsAppInstanceLabel(s.waActiveInstance, next.trim() || null);
    await loadWaInstances();
  } catch (e) {
    s.waError = e.message || t('dashboard.whatsapp.errRenameNumber');
    draw();
  }
}

// ── WhatsApp logic ─────────────────────────────────────────
export async function loadWaInstances() {
  s.waLoading = true; s.waError = ''; draw();
  try {
    const res = await listWhatsAppInstances();
    const list = Array.isArray(res) ? res : (res && res.instances) || [];
    s.waInstances = Array.isArray(list) ? list : [];
    if (s.waInstances.length === 0) {
      // هیچ شماره‌ای نیست → حالت «افزودن اولین شماره»
      s.waActiveInstance = null;
      s.waConnected = false; s.waStatus = 'pending'; s.waPhone = null;
      s.waChats = []; s.waActiveChat = null; s.waMessages = [];
      s.waLoading = false; draw();
      return;
    }
    // اگر instance فعال قبلی هنوز در لیست هست نگهش دار، وگرنه اولی
    let saved = null;
    try { saved = localStorage.getItem('lu_wa_last_instance'); } catch (e) {}
    const stillThere = s.waActiveInstance && s.waInstances.some((i) => i.id === s.waActiveInstance);
    if (!stillThere) {
      const savedExists = saved && s.waInstances.some((i) => i.id === saved);
      s.waActiveInstance = savedExists ? saved : s.waInstances[0].id;
    }
    // وضعیت زنده‌ی همین instance را بگیر (status DB ممکن است stale باشد)
    await loadWaStatus();
  } catch (e) {
    s.waError = e.message || t('dashboard.whatsapp.errLoadNumbers');
    s.waLoading = false; draw();
  }
}

export async function loadWaStatus() {
  s.waLoading = true; s.waError = ''; draw();
  try {
    const st = await getWhatsAppStatus(s.waActiveInstance);
    s.waConnected = !!st.connected;
    s.waStatus = st.status || 'pending';
    s.waPhone = st.phoneNumber || null;
    if (s.waConnected) { s.waQr = ''; stopWaPoll(); loadWaChats(); startWaChatsPoll(); }
  } catch (e) {
    s.waError = e.message || t('dashboard.whatsapp.errLoadStatus');
  } finally {
    s.waLoading = false; draw();
  }
}

// number (اختیاری): برای گرفتن Pairing Code — Evolution فقط با شماره کد می‌دهد
export async function connectWa(number) {
  if (s.waConnecting) return;
  s.waConnecting = true; s.waError = ''; s.waQr = ''; s.waPairing = ''; draw();
  try {
    const res = await connectWhatsApp(s.waActiveInstance, number || null);
    if (res.connected) {
      s.waConnected = true; s.waStatus = 'connected'; s.waQr = ''; stopWaPoll();
    } else {
      s.waQr = res.qr || '';
      s.waPairing = res.pairingCode || '';
      s.waStatus = 'connecting';
      startWaPoll();
    }
  } catch (e) {
    s.waError = e.message || t('dashboard.whatsapp.errConnect');
  } finally {
    s.waConnecting = false;
    if (s.view === 'whatsapp') draw();
  }
}

export async function disconnectWa() {
  stopWaPoll();
  try { await disconnectWhatsApp(s.waActiveInstance); } catch { /* ignore */ }
  s.waConnected = false; s.waStatus = 'disconnected'; s.waQr = ''; s.waPairing = ''; s.waPhone = null; stopWaChatsPoll(); s.waChats = []; s.waActiveChat = null; s.waMessages = [];
  if (s.view === 'whatsapp') draw();
}

export function startWaPoll() {
  stopWaPoll();
  waPollTimer = setInterval(async () => {
    // اگر کاربر از این نما خارج شده، متوقف کن
    if (s.view !== 'whatsapp') { stopWaPoll(); return; }
    try {
      const st = await getWhatsAppStatus(s.waActiveInstance);
      if (st.connected) {
        s.waConnected = true; s.waStatus = 'connected'; s.waPhone = st.phoneNumber || null;
        s.waQr = ''; s.waPairing = '';
        stopWaPoll();
        if (s.view === 'whatsapp') draw();
      }
    } catch { /* poll بعدی دوباره تلاش می‌کند */ }
  }, 3000);
}


// ── Polling زنده برای چت‌ها و پیام‌ها ──────────────────────
// رفرش بی‌صدای پیام‌های چت باز (بدون loading flag، تا چشمک نزند)
export async function refreshWaMessages() {
  if (!s.waActiveChat) return;
  try {
    const res = await getWhatsAppMessages(s.waActiveInstance, s.waActiveChat);
    const newMsgs = res.messages || [];
    // Nur bei echter Änderung neu zeichnen. Die frühere Prüfung verglich bloss
    // die ANZAHL — ein «für alle gelöscht», eine Bearbeitung oder ein
    // nachgeladenes Medium lässt die Anzahl gleich und blieb damit unsichtbar,
    // bis der Nutzer die Ansicht wechselte.
    if (waMessagesSignature(newMsgs) !== waMessagesSignature(s.waMessages)) {
      s.waMessages = newMsgs;
      if (s.view === 'whatsapp') draw();
    }
  } catch { /* poll بعدی دوباره تلاش می‌کند */ }
}

// Rendersignatur der Nachrichten — dieselbe Idee wie msgSig im Mobile-Chat:
// nur die Felder, die die Blase beeinflussen.
export function waMessagesSignature(msgs) {
  return (msgs || []).map((m) =>
    [m.id, m.content, m.messageType, m.mediaPending, m.mediaPath, m.status, m.editedAt, m.revokedAt, m.timestamp].join(':')
  ).join('|');
}

// رفرش بی‌صدای لیست چت‌ها — faghat agar chizi avaz shode bashad draw mikonad
export function waChatsSignature(chats) {
  // emza-ye sabok baraye tashkhis-e taghir (tedad, akharin payam, unread)
  return (chats || []).map((c) =>
    (c.remoteJid || c.jid || '') + ':' + (c.lastMessageAt || '') + ':' + (c.unreadCount || 0) + ':' + (c.contactName || c.pushName || '')
  ).join('|');
}

export async function refreshWaChats() {
  try {
    const res = await getWhatsAppChats(s.waActiveInstance);
    const next = res.chats || [];
    const sigNext = waChatsSignature(next);
    const sigCur = waChatsSignature(s.waChats);
    if (sigNext === sigCur) return; // hich taghiri nist -> redraw nakon
    s.waChats = next;
    if (s.view === 'whatsapp') draw();
  } catch { /* poll بعدی */ }
}

export function startWaChatsPoll() {
  stopWaChatsPoll();
  waChatsPollTimer = setInterval(() => {
    if (s.view !== 'whatsapp' || !s.waConnected) { stopWaChatsPoll(); return; }
    refreshWaChats();
    refreshWaMessages();
  }, 5000);
}

export function stopWaChatsPoll() {
  if (waChatsPollTimer) { clearInterval(waChatsPollTimer); waChatsPollTimer = null; }
}

export function stopWaPoll() {
  if (waPollTimer) { clearInterval(waPollTimer); waPollTimer = null; }
}

